(function () {
  if (window.AUVENNECartJourney || !window.fetch) return;
  var busy = false;
  var sequence = 0;
  var locks = [];

  function rootPath() {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function scopes() {
    return Array.from(document.querySelectorAll('[data-auv-cart-section], cart-drawer'));
  }

  function status(scope, key, error) {
    if (!scope) return;
    var node = scope.querySelector('[data-auv-cart-status]');
    if (!node) {
      var host = scope.querySelector('.drawer__header');
      if (!host) return;
      node = document.createElement('p');
      node.className = 'auv-cart-journey__status';
      node.dataset.auvCartStatus = '';
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      host.insertAdjacentElement('afterend', node);
    }
    node.textContent = scope.dataset[key] || '';
    node.dataset.error = error ? 'true' : 'false';
    scope.dataset.auvCartFailed = error ? 'true' : 'false';
  }

  function setBusy(value) {
    busy = value;
    if (value) {
      locks = [];
      scopes().forEach(function (scope) {
        scope.setAttribute('aria-busy', 'true');
        scope.querySelectorAll('input[data-auv-quantity-key], .quantity__button, [data-auv-remove-key], button[name="checkout"], button[name="update"]').forEach(function (node) {
          locks.push({ node: node, disabled: node.disabled });
          if ('disabled' in node) node.disabled = true;
          node.setAttribute('aria-disabled', 'true');
        });
      });
    } else {
      scopes().forEach(function (scope) { scope.removeAttribute('aria-busy'); });
      locks.forEach(function (lock) {
        if (!lock.node.isConnected) return;
        if ('disabled' in lock.node) lock.node.disabled = lock.disabled;
        lock.node.removeAttribute('aria-disabled');
      });
      locks = [];
    }
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function requestedSections() {
    var ids = [];
    var full = document.querySelector('[data-auv-cart-section]');
    if (full) ids.push(full.dataset.auvCartSection);
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    ids.push('cart-icon-bubble');
    return ids;
  }

  function sectionUrl(ids) {
    var url = new URL(window.location.href);
    url.searchParams.set('sections', ids.join(','));
    return url.pathname + url.search;
  }

  async function completeSections(cart, ids) {
    var html = cart.sections || {};
    var missing = ids.filter(function (id) { return !html[id]; });
    if (!missing.length) return html;
    var response = await fetch(sectionUrl(missing), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('section unavailable');
    var additional = await response.json();
    return Object.assign({}, html, additional);
  }

  function render(cart, html, focusIndex, source) {
    var full = document.querySelector('[data-auv-cart-section]');
    if (full) {
      var fullHtml = html[full.dataset.auvCartSection];
      var nextFull = fullHtml && parse(fullHtml).querySelector('[data-auv-cart-section]');
      if (!nextFull) throw new Error('cart section unavailable');
      full.replaceWith(nextFull);
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var nextDrawer = html['cart-drawer'] && parse(html['cart-drawer']).querySelector('.drawer__inner');
      if (!nextDrawer) throw new Error('drawer section unavailable');
      var current = drawer.querySelector('.drawer__inner');
      if (current) current.replaceWith(nextDrawer);
      drawer.classList.toggle('is-empty', cart.item_count === 0);
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && html['cart-icon-bubble']) {
      var nextBubble = parse(html['cart-icon-bubble']).querySelector('.shopify-section');
      if (nextBubble) bubble.innerHTML = nextBubble.innerHTML;
    }
    if (window.AUVENNECartDrawer) window.AUVENNECartDrawer.applyCart(cart);
    else document.dispatchEvent(new CustomEvent('auvenne:cart-synced', { detail: { cart: cart } }));

    var scope = source === 'drawer' ? drawer : document.querySelector('[data-auv-cart-section]');
    status(scope, 'auvUpdated', false);
    if (scope) {
      var inputs = Array.from(scope.querySelectorAll('[data-auv-quantity-key]'));
      var target = inputs[Math.min(focusIndex, inputs.length - 1)] || scope.querySelector('.drawer__close, .lu__btn, a');
      if (target) {
        if (source === 'drawer' && drawer.classList.contains('active') && typeof trapFocus === 'function') trapFocus(drawer.querySelector('.drawer__inner'), target);
        else target.focus({ preventScroll: true });
      }
    }
  }

  async function change(key, quantity, trigger) {
    if (busy) return;
    var source = trigger.closest('cart-drawer') ? 'drawer' : 'page';
    var sourceScope = trigger.closest('[data-auv-cart-section], cart-drawer');
    var row = trigger.closest('[data-auv-line-key], .cart-item');
    var input = trigger.matches('[data-auv-quantity-key]') ? trigger : row && row.querySelector('[data-auv-quantity-key]');
    var focusIndex = input ? Number(input.dataset.auvLineIndex) || 0 : 0;
    var ids = requestedSections();
    var request = ++sequence;
    var mutated = false;
    setBusy(true);
    status(sourceScope, 'auvUpdating', false);
    try {
      var response = await fetch(rootPath() + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: ids, sections_url: window.location.pathname })
      });
      var cart = await response.json();
      if (!response.ok || cart.errors || !Array.isArray(cart.items)) throw new Error('cart update rejected');
      mutated = true;
      var html = await completeSections(cart, ids);
      if (request !== sequence) return;
      render(cart, html, focusIndex, source);
    } catch (error) {
      if (mutated) {
        window.location.reload();
        return;
      }
      status(sourceScope, 'auvCartError', true);
    } finally {
      if (request === sequence) setBusy(false);
    }
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('input[data-auv-quantity-key]');
    if (!input) return;
    event.stopImmediatePropagation();
    if (busy) return;
    var quantity = Number(input.value);
    if (input.value.trim() === '' || !Number.isInteger(quantity) || quantity < 0 || !input.checkValidity()) {
      input.reportValidity();
      status(input.closest('[data-auv-cart-section], cart-drawer'), 'auvCartError', true);
      return;
    }
    change(input.dataset.auvQuantityKey, quantity, input);
  }, true);

  document.addEventListener('click', function (event) {
    var remove = event.target.closest && event.target.closest('[data-auv-remove-key]');
    if (!remove) return;
    if (remove.tagName === 'A' && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!busy) change(remove.dataset.auvRemoveKey, 0, remove);
  }, true);

  document.documentElement.classList.add('auv-cart-enhanced');
  window.AUVENNECartJourney = { change: change, isBusy: function () { return busy; } };
})();
